import { DeepPartial } from "@apollo/client/utilities";
import { MenuCategoryProxy } from "@me-team/host/main/graphql/types";
import { RequestInputService } from "@me-pos/service-modal";

type CategoryInputWithOrigin = {
    name: string;
    comment: string | null;
    deleted: boolean;
    parentCategoryId: number | null;
    nameOrigin?: string | null;
    commentOrigin?: string | null;
    faviconId?: number | null;
};

const findTopLevelCategoryById = (
    categoryId: number,
    categoryList: DeepPartial<MenuCategoryProxy>[]
): DeepPartial<MenuCategoryProxy> | undefined => {
    return categoryList.find((categoryItem) => categoryItem.id === categoryId);
};

const findSubcategoryByIds = (
    categoryId: number,
    subcategoryId: number,
    categoryList: DeepPartial<MenuCategoryProxy>[]
): DeepPartial<MenuCategoryProxy> | undefined => {
    const parentCategory = findTopLevelCategoryById(categoryId, categoryList);
    return (parentCategory?.childCategories ?? []).find((subcategoryItem) => subcategoryItem.id === subcategoryId);
};

export class EditMenuRequestInputService {
    public static createServiceCategoryInput = (
        categoryId: number | null,
        subcategoryId: number | null,
        categoryList: DeepPartial<MenuCategoryProxy>[]
    ): CategoryInputWithOrigin => {
        const baseInput = RequestInputService.createServiceCategoryInput(categoryId, subcategoryId, categoryList) as {
            name: string;
            comment: string | null;
            deleted: boolean;
            parentCategoryId: number | null;
            faviconId?: number | null;
        };

        if (!categoryId || !subcategoryId) {
            const currentCategory = categoryId ? findTopLevelCategoryById(categoryId, categoryList) : undefined;

            return {
                ...baseInput,
                nameOrigin: currentCategory?.nameOrigin ?? null,
                commentOrigin: currentCategory?.descriptionOrigin ?? null,
            };
        }

        const currentSubcategory = findSubcategoryByIds(categoryId, subcategoryId, categoryList);

        return {
            ...baseInput,
            nameOrigin: currentSubcategory?.nameOrigin ?? null,
            commentOrigin: currentSubcategory?.descriptionOrigin ?? null,
        };
    };

    public static createCategoryInputFromFormData = RequestInputService.createCategoryInputFromFormData;
}
